<div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
  <mat-card class="px-2 py-4  shadow m-3">
  <h4 class="new-product-blk-title" style="margin: 1rem 2rem;">Add Fee Details</h4>
  <div class="loyalty-grid-container px-3">
    <div class="generate-promocode-form-container">
      <form [formGroup]="feeConfigForm" (ngSubmit)="onSubmit()">
        <div class="form-container">
          <div class="row">
            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                Payment Type<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 align-self-center">
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="paymentInput">
                      <mat-select formControlName="paymentType" required>
                        <mat-option value="" disabled>Select a payment type</mat-option>
                        <mat-option value="CreditCard">Credit Card</mat-option>
                        <mat-option value="Paypal">PayPal</mat-option>
                        <mat-option value="GooglePay">Google Pay</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
            </div>
          </div>
          <div class="row my-2">
            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center">
              <h4 class="form-item-label">
                Fee<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 align-self-center">
              <div class="row g-0">
                <div class="col-3">
                  <div class="form-item-input">
                    <mat-form-field class="w-100 mat-field-split-left" appearance="outline">
                      <mat-select formControlName="feeType" required>
                        <mat-option value="$">$</mat-option>
                        <mat-option value="%">%</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-8">
                  <div class="form-item-input">
                    <mat-form-field class="mat-field-split-right" appearance="outline">
                      <input matInput type="number" placeholder="Enter Fee" formControlName="feeAmount" required min="0" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-1">
                </div>
              </div>
            </div>
          </div>          
          <div class="row mt-4">
            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0">
                {{ "pages.Promocodehistory.Validity" | translate
                }}<span class="required">*</span>
              </h4>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <div class="row">
                <div class="col-12 col-xs-12 col-sm-6">
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input matInput formControlName="startDate" [matDatepicker]="picker" placeholder="{{
                          'pages.Creditlinereport.From' | translate
                        }}" />
                      <!-- <span matPrefix>{{'pages.Creditlinereport.From' | translate }}</span> -->
                      <mat-datepicker-toggle matSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-12 col-xs-12 col-sm-6">
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input matInput formControlName="endDate" [matDatepicker]="picker1" placeholder="{{
                          'pages.Creditlinereport.To' | translate
                        }}" />
                      <mat-datepicker-toggle matSuffix [for]="picker1">
                        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-footer">
            <ul class="list-inline text-center">
              <li class="list-inline-item">
                <button mat-raised-button [disabled]="!feeConfigForm.valid" color="primary" type="submit">
                  <span translate class="translate">Save</span>
                </button>
              </li>
              <li class="list-inline-item">
                <button mat-stroked-button color="primary" type="button" (click)="onCancel()">
                  <span translate class="translate">pages.newRetailer.cancel</span>
                </button>
              </li>
            </ul>
          </div>
      </div>    
      </form>
    </div>
  </div>
  </mat-card>
</div>